import * as React from "react";
import { SVGProps } from "react";
import Typography from "./Typography";

interface BubbleBackgroundProps extends SVGProps<SVGSVGElement> {
  title?: string;
  subtitle?: string;
  wrapperClassName?: string;
  textContainerClassName?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  bubbleSide?: "left" | "right";
}

const BubbleBackground: React.FC<BubbleBackgroundProps> = ({
  title = "Welcome on board!",
  subtitle = "Let's get started and have fun along the way!",
  wrapperClassName = "",
  textContainerClassName = "",
  titleClassName = "",
  subtitleClassName = "",
  bubbleSide = "left",
  ...svgProps
}) => (
  <div className={`relative z-10  ${wrapperClassName}`}>
    <div className={`absolute w-48 inset-0  translate-x-16 -translate-y-6 z-10 flex gap-1 flex-col items-center justify-center ${textContainerClassName}`}>
      <Typography
        variant="p"
        color="none"
        className={`text-system-blue ${bubbleSide === "right" ? "scale-x-[-1]" : ""} text-center m-0 ${titleClassName}`}
        weight="semibold"
      >
        {title}
      </Typography>
      <Typography
        variant="small"
        className={`text-center m-0 ${bubbleSide === "right" ? "scale-x-[-1]" : ""} leading-[140%] ${subtitleClassName}`}
      >
        {subtitle}
      </Typography>
    </div>
    <svg
      width={277}
      height={243}
      viewBox="0 0 277 243"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <g clipPath="url(#clip0_1554_7054)">
        <mask
          id="mask0_1554_7054"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={188}
          width={59}
          height={55}
        >
          <path
            d="M0 188H59V243H0V188Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1554_7054)">
          <path
            d="M15.3493 197.344C22.6906 197.344 28.583 202.998 28.583 210.322C28.583 217.645 22.6906 223.299 15.3493 223.299C8.00808 223.299 2.11353 217.645 2.11353 210.322C2.11353 202.998 8.006 197.344 15.3493 197.344ZM12.5531 216.121C15.7988 216.121 18.2963 213.811 18.2963 210.322C18.2963 206.832 15.7988 204.522 12.5531 204.522C9.30735 204.522 6.80984 206.832 6.80984 210.322C6.80984 213.811 9.30528 216.121 12.5531 216.121Z"
            fill="rgb(var(--pd-ink))"
          />
          <path
            d="M43.3313 197.607C50.6186 197.607 56.4696 203.219 56.4696 210.49C56.4696 217.76 50.6207 223.374 43.3313 223.374C36.0419 223.374 30.1909 217.762 30.1909 210.49C30.1909 203.217 36.0398 197.607 43.3313 197.607ZM40.5351 216.175C43.758 216.175 46.2369 213.882 46.2369 210.416C46.2369 206.949 43.7559 204.656 40.5351 204.656C37.3142 204.656 34.8333 206.949 34.8333 210.416C34.8333 213.882 37.3122 216.175 40.5351 216.175Z"
            fill="rgb(var(--pd-ink))"
          />
          <path
            d="M35.0413 228.653C36.0035 231.937 38.987 233.418 42.0645 232.514C45.14 231.611 46.8977 228.739 45.997 225.436L53.1442 223.338C53.1442 223.338 53.1453 223.342 53.1458 223.344C55.1204 230.332 51.0239 237.374 44.0203 239.43C37.0147 241.488 29.8703 237.745 27.8937 230.758C27.8937 230.758 27.8926 230.754 27.8921 230.752L35.0393 228.654L35.0413 228.653Z"
            fill="rgb(var(--pd-ink))"
          />
        </g>
        <mask
          id="mask1_1554_7054"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={29}
          y={0}
          width={248}
          height={209}
        >
          <path
            d="M29 0H277V209H29V0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_1554_7054)">
          <path
            d="M160.35 0.5C145.724 0.5 132.509 3.97006 122.968 9.55371C113.415 15.1443 107.629 22.7943 107.629 31.1436C107.629 33.2454 107.997 35.3033 108.695 37.2871L107.888 37.8232C99.5802 30.289 88.127 25.626 75.4648 25.626C50.2231 25.6261 29.8007 44.1493 29.5068 67.001L29.5078 67.501C29.508 85.6835 42.2562 101.19 60.1016 106.962L59.9482 107.938C54.7603 107.938 49.1595 108.827 45.1104 111.929C41.1025 114.999 38.5106 120.322 39.4971 129.446L39.5 129.473V129.5C39.5 137.053 44.6324 146.895 53.207 154.208C61.7614 161.504 73.6665 166.215 87.124 163.611C87.1292 163.61 87.1354 163.609 87.1406 163.608L87.3145 164.593C87.3084 164.594 87.3019 164.595 87.2959 164.596C86.8403 164.669 86.4165 165.025 86.0498 165.714C85.6862 166.397 85.4266 167.326 85.2715 168.351C84.979 170.283 85.0763 172.408 85.4053 173.613L85.4746 173.842C86.1999 176.018 87.4517 178.052 89.3838 179.542C91.3118 181.029 93.9511 182 97.5 182C100.951 182 104.145 180.003 106.498 177.371C108.86 174.73 110.274 171.563 110.274 169.378C110.274 169.19 110.255 169.013 110.23 168.795L110.163 168.187L110.772 168.241C114.41 168.571 118.135 168.744 121.938 168.744C142.366 168.744 160.757 163.832 173.733 155.978L174.021 155.804L174.29 156.003C184.92 163.876 199.348 168.736 215.27 168.736C248.084 168.736 274.453 148.193 274.453 123.108C274.453 112.034 269.327 101.868 260.766 93.9404L260.186 93.4033L260.918 93.1094C270.287 89.3445 276.5 82.1671 276.5 74.0459C276.5 68.5935 273.707 63.5774 269.03 59.7197C264.352 55.8612 257.808 53.1821 250.387 52.4297L249.716 52.3623L249.976 51.7402C250.998 49.2921 251.567 46.597 251.567 43.7783C251.567 32.3737 242.335 23.126 230.952 23.126C223.897 23.126 217.664 26.6825 213.95 32.1045L212.979 33.5225L213.038 31.8047C213.048 31.515 213.069 31.3747 213.069 31.1436C213.069 22.7943 207.283 15.1443 197.73 9.55371C188.189 3.97011 174.975 0.500059 160.35 0.5Z"
            fill="rgb(var(--pd-cream))"
            stroke="rgb(var(--pd-cream))"
          />
          <path
            d="M85.3926 186.242C83.2736 186.242 81.3806 186.795 80.0332 187.665C78.6811 188.537 77.9327 189.683 77.9326 190.875C77.9326 192.068 78.6809 193.215 80.0332 194.087C81.3806 194.956 83.2736 195.51 85.3926 195.51C87.5113 195.51 89.4036 194.956 90.751 194.087C92.1033 193.215 92.8516 192.068 92.8516 190.875C92.8514 189.683 92.1032 188.537 90.751 187.665C89.4036 186.795 87.5114 186.242 85.3926 186.242Z"
            fill="rgb(var(--pd-cream))"
            stroke="rgb(var(--pd-cream))"
          />
          <path
            d="M76.5908 203.586C75.4074 203.586 74.3591 203.896 73.6221 204.372C72.8801 204.851 72.509 205.453 72.5088 206.043C72.5088 206.633 72.8799 207.236 73.6221 207.715C74.3591 208.191 75.4074 208.501 76.5908 208.501C77.7742 208.501 78.8226 208.191 79.5596 207.715C80.3017 207.236 80.6729 206.633 80.6729 206.043C80.6727 205.453 80.3016 204.851 79.5596 204.372C78.8225 203.896 77.7742 203.586 76.5908 203.586Z"
            fill="rgb(var(--pd-cream))"
            stroke="rgb(var(--pd-cream))"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1554_7054">
          <rect
            width={277}
            height={243}
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
);
export default BubbleBackground;
